module.exports = __webpack_public_path__ + "img/time.866bb95e.svg";